import { IComboChartData } from "./ComboChart/IComboChartData";
import { ISharedColumnChartData } from "./ISharedColumnChartData";
import { IPieChartData } from "./PieChart/IPieChartData";

export const processSharedColumnChartColors = (data: ISharedColumnChartData) => {
    if (data == null) return [];
    if (data.datasets == null) return [[]];
    var processedColors: Array<string> = [];
    data.datasets.forEach(function (dataset) {
        processedColors.push(dataset.backgroundColor);
    });
    return processedColors;
};

export const processPieChartColors = (data: IPieChartData) => {
    if (data == null) return [];
    if (data.datasets == null) return [[]];
    var processedColors: Array<string> = [];
    data.datasets.forEach(function (dataset) {
        processedColors.push(dataset.backgroundColor);
    });
    return processedColors;
};

export const processComboChartColors = (data: IComboChartData) => {
    if (data == null) return [];
    if (data.datasets == null) return [[]];
    var processedColors: Array<string> = [];
    data.datasets.forEach(function (dataset) {
        processedColors.push(dataset.backgroundColor[0]);
    });
    return processedColors;
};